/*
 * Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
 * This software is the proprietary information of Irian Software Development SRL.
 * Use is subject to license and non-disclosure terms
 */
import {Pipe, PipeTransform} from '@angular/core';

/*
 * Limit the string to a defined (or default) number of chars
 * Optionally add 3 ending dots: Esti cu m...
 * Usage:
 *   value | exponentialStrength: numberOfChars, addDots
 * Example:
 *   {{ "Ana are mere" | stringLimit: 5, false }}
 *   formats to: "Ana a"
 *   {{ "Ana are mere" | stringLimit: 5, true }}
 *   formats to: "Ana a..."
*/

@Pipe({name: 'stringLimit'})
export class StringLimitPipe implements PipeTransform {
  transform(value: string, numberOfChars: number, addDots: boolean): string | null {

    if (value != null) {
      const stringLength = value.length;
      const dots = "...";

      if (numberOfChars >= stringLength) {
        return value;
      }

      return addDots ? value.substring(0, numberOfChars) + dots : value.substring(0, numberOfChars);
    }
    return null;
  }
}
